"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoContainer = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var useMediaContext_1 = require("../context/useMediaContext");

var InfoContainer = function InfoContainer(_ref) {
  var children = _ref.children,
      titleString = _ref.titleString,
      _ref$bottomPadding = _ref.bottomPadding,
      bottomPadding = _ref$bottomPadding === void 0 ? true : _ref$bottomPadding,
      className = _ref.className;

  var _useMediaContext_1$us = useMediaContext_1.useMediaContext(),
      getStyles = _useMediaContext_1$us.getStyles,
      getString = _useMediaContext_1$us.getString;

  return jsx_runtime_1.jsxs("div", Object.assign({}, getStyles("infoContainer", className, {
    bottomPadding: bottomPadding
  }), {
    children: [jsx_runtime_1.jsx("h4", Object.assign({}, getStyles("fullLabel"), {
      children: getString(titleString)
    }), void 0), children]
  }), void 0);
};

exports.InfoContainer = InfoContainer;